import axios from 'axios';
import { API_GET_ALL_USERS, API_CREATE_USER, API_EDIT_USER } from '../../constants'

export default {
  state: {
    users: []
  },
  mutations: {
    SET_USERS: (state, payload) => {
      state.users = payload;
    },
    SET_USER: (state, payload) => {
      const index = state.users.findIndex(x => x.id === payload.id);
      if (index !== -1) {
        state.users[index] = payload;
      }
      else {
        state.users.push(payload);
      }
    }
  },
  actions: {
    FETCH_USERS: async (context) => {
      let usersResponse = await axios.get(API_GET_ALL_USERS);
      const users = usersResponse.data.result.data;
      context.commit('SET_USERS', users);
      return users;
    },
    UPDATE_USER: async (context, payload) => {
      try {
        await axios.put(API_EDIT_USER, payload);
        context.commit('SET_USER', payload);
        context.commit('PUSH_SUCCESS', 'Пользователь успешно сохранен');
        return true;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return false;
      }
    },
    CREATE_USER: async (context, payload) => {
      try {
        let userResponse = await axios.post(API_CREATE_USER, payload);
        context.commit('SET_USER', userResponse.data.result);
        context.commit('PUSH_SUCCESS', 'Пользователь успешно создан');
        return true;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return false;
      }
    },

  },
  getters: {
    USERS: state => {
      return state.users;
    },
    USER_BY_ID(state) {
      return userId => {
        return state.users.find(user => user.id === userId)
      }
    }
  }
}